export default __webpack_public_path__ + "static/media/2.cc4d4bf5.jpg";